export const INITIALIZE_TILES = 'INITIALIZE_TILES';
export const INITIALIZE_SNAKE = 'INITIALIZE_SNAKE';

export const SET_GAME_STATUS = 'SET_GAME_STATUS';
export const SET_SNAKE_SPEED = 'SET_SNAKE_SPEED';
export const SET_SNAKE_ORIENTATION = 'SET_SNAKE_ORIENTATION';
export const SET_TARGET_ORIENTATION = 'SET_TARGET_ORIENTATION';
export const CHANGE_TARGET_ORIENTATION = 'CHANGE_TARGET_ORIENTATION';

export const SET_MOVE_TIMER = 'SET_MOVE_TIMER';
export const CLEAR_MOVE_TIMER = 'CLEAR_MOVE_TIMER';
export const SNAKE_MOVE = 'SNAKE_MOVE';

export const SET_SCORE = 'SET_SCORE';
export const ADD_SCORE = 'ADD_SCORE';

export const TILES_SNAKE_MOVE = 'TILES_SNAKE_MOVE';
export const TILES_EAT_EGG = 'TILES_EAT_EGG';
export const SNAKE_SNAKE_MOVE = 'SNAKE_SNAKE_MOVE';
export const SNAKE_EAT_EGG = 'SNAKE_EAT_EGG';
export const GENERATE_EGG = 'GENERATE_EGG';


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js